import TableCommonHook from '@op/components/TableCommonHook';
import { reviewsFormat } from '@op/utils/value';
import React, { useMemo } from 'react';
import { useIntl } from 'umi';

const MentionsTable = ({
  filter,
  records,
  seriesDataKeys,
  specialHeight,
  eventsDict
}: any) => {
  const { formatMessage } = useIntl();
  const columns = useMemo(() => {
    const list = seriesDataKeys.map(
      ({ text, key, format = reviewsFormat }: any) => {
        return {
          header: formatMessage({ id: text }),
          key,
          render: (cvm: any) => {
            const value = cvm[key];
            return format(value);
          },
        };
      },
    );

    return [
      { header: formatMessage({ id: 'Date' }), key: 'time', align: 'left' },
      ...list,
    ];
  }, [filter, formatMessage]);

  return (
    <div className={`dbo-gamestore-chart-legend ${specialHeight === 0 ? 'dbo-gamestore-mentions-chart' : ''}`} >
      <TableCommonHook
        recordKey={'time'}
        records={records}
        total={records.length}
        columns={columns}
        maxHeight={196 + specialHeight}
        minWidth={0}
        hasPageable={false}
        {...eventsDict}
      />
    </div>
  );
};

export default MentionsTable;
